import { APIService } from "./APIService"
import { AddSurveyType, Page, SurveyType } from "./types"

const getSurveys = (page: number) =>
  APIService.get<null, Page<SurveyType>>(`/profiles/:profileId/surveys?page=${page}`)

const searchSurveys = (q: string) =>
  APIService.get<null, Page<SurveyType>>(`/profiles/:profileId/short-surveys?q=${q}`)

const addSurvey = (body: AddSurveyType) =>
  APIService.post<null, SurveyType>(`/profiles/:profileId/surveys`, body)

export const ProfileSurveyService = {
  getSurveys,
  addSurvey,
  searchSurveys,
}
